import { Injectable } from '@angular/core';
import { PolicyInfo } from './app.models';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const httpOptions: { headers; responseType } = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  responseType: 'text'
};

@Injectable({
  providedIn: 'root'
})
export class PolicyUpdateService {
  constructor(private http: HttpClient) { }

  public publishPolicyUpdate(policyInfo: PolicyInfo, url: string, hash: string): Observable<any> {
    const request = this.createRequest(hash, policyInfo);
    return this.http.post(url, request, httpOptions);
  }

  private createRequest(hash: string, policyInfo: PolicyInfo) {
    return {
      PolicyHash: hash,
      FirstName: policyInfo.FirstName,
      LastName: policyInfo.LastName,
      MiddleInitial: policyInfo.MiddleInitial,
      ZipCode: policyInfo.ZipCode,
      EmailAddress: policyInfo.EmailAddress,
      PhoneNumber: policyInfo.PhoneNumber
    };
  }
}
